<template>
  <div>
    <b-container fluid class="mt-3">
      <b-row>
        <b-col>
          <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center mb-3 border-bottom border-light">
            <h5>ホーム</h5>
            <div class="d-flex float-right">
              <!-- <h5 class="text-secondary"><b-badge variant="light">最終更新 : 2022/05/01 11:22:33</b-badge></h5>
              <b-button size="sm" class="mb-2" variant="outline-secondary">
                データを更新する<b-icon icon="arrow-clockwise" aria-label="Help" class="ml-1"></b-icon>
              </b-button> -->
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card-group>
            <b-card class="shadow-sm">
              <template #header>
                <h6 class="mb-0">インフォメーション</h6>
              </template>
              <b-alert variant="success" show class="mb-0">
                正常稼働中です。
              </b-alert>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
    }
  },
  // Initialized Event & Lifecycle
  beforeCreate() {
  },
  // Initialized Injection & Reactivity
  created() {
  },
  // Processed the following
  beforeMount() {
    // 1.Has "el" option?
    //   Yes  -> No action
    //   No   -> vm.&mount(el) is called.
    // 2.Has "template" option?
    //   Yes  -> Compile template into render function.
    //   No   -> Compile el's outerHTML as template
  },
  // Created vm.$el and replaced "el" with it.
  mounted() {
  },
  // Data changed in mounted state.
  beforeUpdate() {
  },
  // Virtual DOM re-rendered and patched in mounted state.
  updated() {
  },
  // vm.$destroy() is called.
  beforeUnmount() {
  },
  // Teardown completed watchers, child components and event listeners
  unmounted() {
  },
  computed: {
    // Getter of ...
  },
  watch: {
  },
  methods:{
  }
}
</script>
